import { useCurrentUser } from '@frontend/features/auth/hooks/useCurrentUser';

/**
 * Hook for checking user permissions based on their role.
 *
 * Provides permission flags and helper methods for role-based access control:
 * - Admin and PNOps can perform mutations (create, update, delete)
 * - ViewOnly can only read data
 *
 * @returns Permission flags and role information
 */
export function usePermissions() {
  const { user, isLoading } = useCurrentUser();

  const canMutate = user?.role === 'Admin' || user?.role === 'PNOps';
  const isViewOnly = user?.role === 'ViewOnly';
  const isAdmin = user?.role === 'Admin';
  const isPNOps = user?.role === 'PNOps';

  const getPermissionMessage = () => {
    if (isViewOnly) {
      return 'You have view-only access. Contact your administrator to request edit permissions.';
    }
    if (!user?.role) {
      return 'No role assigned. Contact your administrator.';
    }
    return null;
  };

  return {
    canMutate,
    isViewOnly,
    isAdmin,
    isPNOps,
    role: user?.role,
    permissionMessage: getPermissionMessage(),
    isLoading,
  };
}
